<!--
  DocumentTypesFilter renders a filter with dropdown options for document types
  and reads/writes from the `document_types` URL query param.
-->

<script>
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

const PARAM_TO_LABEL_MAP = {
  BANK_STATEMENT: 'Bank Statement',
  PAYSLIP: 'Pay Slip',
  TAX_FORM: 'Tax Form',
  INVOICE: 'Invoice',
  UTILITY_BILL: 'Utility Bill',
  DRIVING_LICENSE: 'Driving License',
  CHECK: 'Check',
  BUSINESS_FILING: 'Business Filing',
  SOCIAL_SECURITY_CARD: 'Social Security Card',
  LEASE: 'Lease',
  FINANCIAL_STATEMENT: 'Financial Statement',
  BENEFITS_STATEMENT: 'Benefits Statement',
  INSURANCE_STATEMENT: 'Insurance Statement',
  BANK_LETTER: 'Bank Letter',
  UNKNOWN: 'Unknown',
};

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: Object.values(PARAM_TO_LABEL_MAP).map((label) => ({ label })),
    };
  },
  computed: {
    value() {
      const { document_types } = this.params;
      if (!document_types) {
        return [];
      }
      let paramsAsArray = [];
      if (typeof document_types === 'string') {
        paramsAsArray = [document_types];
      } else {
        paramsAsArray = document_types;
      }
      // convert param like `UTILITY_BILL` to label like `Utility Bill`
      const mapEntries = Object.entries(PARAM_TO_LABEL_MAP);
      const formatted = paramsAsArray.map((p) => {
        const entry = mapEntries.find(([param]) => param === p);
        return (entry?.length && entry[1]) || '';
      });
      return formatted;
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const mapEntries = Object.entries(PARAM_TO_LABEL_MAP);
      const updatedValuesAsParams = updated.selection.map((t) => {
        const [param] = mapEntries.find(([, label]) => label === t.label);
        return param;
      });
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          document_types:
            updatedValuesAsParams.length > 0
              ? updatedValuesAsParams
              : undefined,
        },
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Document Type"
    :options="options"
    :value="value"
    data-testid="document-types-filter"
    @selection-changed="onSelectionChanged"
  />
</template>
